export default __webpack_public_path__ + "static/media/Silk-Serif-ExtraLight-Italic.5c5b0dc8.otf";